export const PortalChatMessageMaxCharacters = 1_048_576;
export const PortalChatJsonBodyLimit = '8mb';
export const FoundryMaxOutputTokens = 128_000;
export const FoundryDefaultMaxOutputTokens = 32_000;
export const FoundryContextCompactionThreshold = 700_000;